












































































































































































































































































import { Component, mixins } from 'nuxt-property-decorator'
import BaseModal from '../../components/modals/BaseModal.vue'
import CloseModalButton from '../../components/modals/CloseModalButton.vue'
import { UserAuthMixin, UserMixin } from '~/node_modules/sitis-nuxt/lib/mixins'

@Component({
  components: {
    BaseModal,
    CloseModalButton,
  },
})
export default class LoginModal extends mixins(UserMixin, UserAuthMixin) {
  username = '';
  password = '';
  canRequestAgain = false;
  $modal: any;

  get submitIsDisabled(): boolean {
    return ![this.username, this.password].every(Boolean);
  }

  onBeforeOpen({
    params
  }: {
    params?: { phoneNumber?: string; canRequestAgain?: boolean };
  }): void {
    this.username = (params && params?.phoneNumber) || "";
    this.canRequestAgain = (params && params.canRequestAgain) || false;
    this.password = "";
  }

  async submitForm(): Promise<void> {
    if (!this.submitIsDisabled) {
      const tokens = await this.login({
        username: this.username,
        password: this.password,
      });
      if (tokens) {
        this.setToken({
          sessionToken: tokens.sessionToken,
          authToken: tokens.authToken,
        });
        this.getUser({expanded: true});
        this.close();
      }
    }
  }

  toRequestPassword(): void {
    const params: { phoneNumber?: string } = {};
    if (this.username) {
      params.phoneNumber = this.username;
    }
    this.$modal.show("request-password-modal", params);
    this.close();
  }

  toLogin(): void {
    this.$modal.show("registration-modal");
    this.close();
  }

  close(): void {
    this.$modal.hide("login-modal");
  }
}
